<template>
  <b-modal
    id="modal-excluir-composto"
    no-close-on-backdrop
    centered
    hide-footer
    hide-header
    size="md"
    content-class="modal-add"
  >
    <template #default>
      <b-container fluid>
        <b-row class="justify-content-center mt-2">
          <b-col cols="auto">
            <b-icon
              icon="question-circle-fill"
              style="color: #3b3b3b; width: 50px; height: 50px"
            ></b-icon>
          </b-col>
        </b-row>
        <b-row class="justify-content-center mt-3">
          <b-col cols="12" class="mb-4">
            <p class="text1-modal">Selecione uma opção</p>
          </b-col>
        </b-row>

        <div class="options-form mb-5">
          <b-form-group>
            <b-form-radio-group
              id="exclusao-options"
              v-model="selected"
              name="exclusao-options"
            >
              <b-form-radio style="display: block" value="excluir">
                Excluir composto do sistema</b-form-radio
              >

              <div v-if="verifyDiscard" style="display: block">
                <b-form-radio style="display: block" value="descartar">
                  Descartar composto</b-form-radio
                >
              </div>
              <div v-else>
                <b-form-radio style="display: block" value="reverter">
                  Reverter descarte</b-form-radio
                >
              </div>
            </b-form-radio-group>
          </b-form-group>
        </div>

        <b-row class="justify-content-center mb-3">
          <b-col cols="auto">
            <button
              class="button-modal btn-one"
              @click="$bvModal.hide('modal-excluir-composto')"
            >
              VOLTAR
            </button>
          </b-col>
        </b-row>
        <b-row class="justify-content-center mb-2">
          <b-col cols="auto">
            <button
              class="button-modal btn-two add"
              type="button"
              @click="confirmar()"
            >
              CONFIRMAR
            </button>
          </b-col>
        </b-row>
      </b-container>
    </template>
  </b-modal>
</template>

<script>
import showError from '../../utils/showError';

export default {
  data() {
    return {
      selected: '',
    };
  },
  props: {
    isDiscarded: Boolean,
  },

  methods: {
    responseModal(isConfirm) {
      this.$emit('responseModal', isConfirm);
    },

    confirmar() {
      if (this.selected === 'excluir') {
        if (this.isDiscarded === true) {
          this.$bvModal.show('modal-confirmation-delete');
        } else {
          showError('Descarte o composto primeiro!');
        }
      } else {
        this.$emit('compostoTrocado', this.selected);
      }
    },
  },
  computed: {
    verifyDiscard() {
      return this.isDiscarded === false;
    },
  },
};
</script>

<style>
.modal-add {
  background-color: #e8e8e8;
  padding: 8px;
  border-radius: 12px;
  border: none;
}

.options-form,
.interrogacao,
.circulo {
  width: fit-content;
  margin: auto;
}

.text1-modal,
.button-modal {
  font-family: 'Inter', sans-serif;
  font-style: normal;
}

.text1-modal {
  text-align: center;
  font-size: 1.8rem;
  font-weight: 900;
}

.button-modal {
  min-width: fit-content;
  width: 196px;
  height: 28px;
  font-size: 12px;
  line-height: 12px;
  letter-spacing: 0.35em;
  font-weight: 700;
  border-radius: 13px;
}

.button-modal:focus {
  outline: none;
}

.btn-one {
  color: #272727;
  border: 1px solid #272727;
  background-color: transparent;
}

.btn-two.add {
  color: white;
  border: none;
}

.btn-two.add {
  background-color: #4dae89;
}

input[type='radio']:checked {
  accent-color: #e8e8e8;
}
</style>
